import React from 'react';
import { useNavigate } from 'react-router-dom';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//style
import styles from 'src/asset/scss/style/notify.module.scss';

export default React.memo( function Notify(props) {
    const { data, toggle, setToggle } = props;//props
    const navigator = useNavigate();//navigator

    /* =============== 자세히보기 - 토글 =============== */
    const toggleHandler = () => {
        let isToggle = null;
        if(toggle !== data) { isToggle = data; }
        setToggle(isToggle);
    }
    /* =============== 자세히보기 - 토글 =============== */
    /* =============== 알림상태필터 =============== */
    const typeFilter = (type) => {//type 유형-1.새요청, 2.예약변경, 3.예약취소, 4.기타
        switch(type) {
            case 1: return "새요청";
            case 2: return "예약변경";
            case 3: return "예약취소";
            case 4: return "기타";
            default : return "기타";
        }
    }
    /* =============== 알림상태필터 =============== */

    return (
        <>
        <div onClick={(e) => toggleHandler()}>
            <div className={styles.infoArea}>
                {/* <label>{data.SUBJECT}</label> */}
                <label>{typeFilter(data.TYPE)}</label>
                <span>{data.REG_DT}</span>
            </div>
            <div className={styles.btnArea}>
                {data.LINK !== undefined && data.LINK !== null ? <button onClick={(e) => navigator(`/schedule`, {state:data.LINK})} className={styles.btnLink}>스케줄 보기</button> : null}
                <button>{toggle === data ? <FontAwesomeIcon icon="fa-light fa-chevron-up" /> : <FontAwesomeIcon icon="fa-light fa-chevron-down" />}</button>
            </div>
        </div>
        {toggle === data ? <article>{data.CONTENT}</article> : null}
        </>
    );
});